"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawerTheme = void 0;
var drawerTheme = {
  root: {
    zIndex: 1
  },
  paper: {
    marginTop: 0,
    top: undefined
  }
};
exports.drawerTheme = drawerTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RyYXdlci9kcmF3ZXJUaGVtZS50c3giXSwibmFtZXMiOlsiZHJhd2VyVGhlbWUiLCJyb290IiwiekluZGV4IiwicGFwZXIiLCJtYXJnaW5Ub3AiLCJ0b3AiLCJ1bmRlZmluZWQiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUdPLElBQU1BLFdBQTJELEdBQUc7QUFDekVDLEVBQUFBLElBQUksRUFBRTtBQUNKQyxJQUFBQSxNQUFNLEVBQUU7QUFESixHQURtRTtBQUl6RUMsRUFBQUEsS0FBSyxFQUFFO0FBQ0xDLElBQUFBLFNBQVMsRUFBRSxDQUROO0FBRUxDLElBQUFBLEdBQUcsRUFBRUM7QUFGQTtBQUprRSxDQUFwRSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IERyYXdlckNsYXNzS2V5IH0gZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUnO1xuaW1wb3J0IHsgQ1NTUHJvcGVydGllcyB9IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlL3N0eWxlcy93aXRoU3R5bGVzJztcblxuZXhwb3J0IGNvbnN0IGRyYXdlclRoZW1lOiBQYXJ0aWFsPFJlY29yZDxEcmF3ZXJDbGFzc0tleSwgQ1NTUHJvcGVydGllcz4+ID0ge1xuICByb290OiB7XG4gICAgekluZGV4OiAxLFxuICB9LFxuICBwYXBlcjoge1xuICAgIG1hcmdpblRvcDogMCxcbiAgICB0b3A6IHVuZGVmaW5lZCxcbiAgfSxcbn07XG4iXX0=